import { CheckCircle2, Printer, Inbox, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { ReceiptPaper } from "../Receipt";
import { useAuth } from "../../context/AuthContext";
import { useHardware } from "../../context/HardwareContext";
import { rp } from "../../lib/format";

export const ReceiptDialog = ({ tx, onClose, title = "Transaksi Berhasil" }) => {
  const { store } = useAuth();
  const { printReceipt, openDrawer, width } = useHardware();
  if (!tx || !store) return null;
  return (
    <Dialog open={!!tx} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md max-h-[95vh] overflow-y-auto" data-testid="receipt-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <CheckCircle2 className="h-5 w-5 text-success" /> {title}
          </DialogTitle>
          <DialogDescription className="font-mono">{tx.invoice}</DialogDescription>
        </DialogHeader>
        {tx.payment_method === "tunai" && (
          <div className="rounded-xl p-4 flex justify-between items-center drawer-pop" style={{ background: "hsl(var(--success) / .12)" }}>
            <span className="font-medium">Kembalian</span>
            <span className="font-mono font-bold text-2xl text-success" data-testid="receipt-change">{rp(tx.change)}</span>
          </div>
        )}
        <div className="bg-muted/60 rounded-xl py-5 overflow-x-auto">
          <ReceiptPaper tx={tx} store={store} width={width} />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <Button variant="outline" onClick={() => printReceipt(tx)} data-testid="print-receipt-btn"><Printer className="h-4 w-4 mr-2" />Cetak Struk</Button>
          <Button variant="outline" onClick={openDrawer} data-testid="open-cashdrawer-btn"><Inbox className="h-4 w-4 mr-2" />Buka Laci</Button>
        </div>
        <Button className="w-full h-11" onClick={onClose} data-testid="new-transaction-btn"><Plus className="h-4 w-4 mr-2" />Selesai</Button>
      </DialogContent>
    </Dialog>
  );
};
